const utils = require('frontend-controller/lib/utils')

module.exports = {
	config: {
		staticLookupName: 'mblxController'
	},

	model: {},

	methods: {
		handleError(context){
			const error = (context.error || {}).fullError || {}

			if(error.statusCode === 500 && error.errorCode === 'MBLX_REQUEST_PRODUCTS_ADDITIONAL_INFORMATION_ERROR'){
				context.errorUnhandled = false

				// tell other components about changes. (e.g., transportErrors might have been written)
				this.callHandler('productAdditionalInformationRequested')

				return this.performMessage({
					messageDisplay: {
						message: 'error:mblx.productAdditionalInformation.requestProductAdditionalInformation.transport',
					}
				})
			} else if(error.statusCode === 409 && error.errorCode === 'MBLX_REQUEST_PRODUCTS_ADDITIONAL_INFORMATION_INSUFFICIENT_RIGHTS_ERROR'){
				context.errorUnhandled = false
				return this.performMessage({
					messageDisplay: {
						message: 'error:mblx.productAdditionalInformation.requestProductAdditionalInformation.insufficientRights',
					}
				})
			}

			context.errorUnhandled = true
			return utils.promise.resolve(context)
		},

		showInsert: function(type, actionResourceRegister){
			var self = this;
			var typeGranted = false;
			var baseActionKey = 'showInsert_' + (type || '');

			if(type === 'product'){
				typeGranted = true;
			}

			if(typeGranted && self.actions[baseActionKey]){
				return self.performAndStoreAction(
					undefined,
					this.prepareAction(baseActionKey, undefined, actionResourceRegister || {}),
					true
				);
			}

			return utils.promise.reject();
		},

		showEdit: function(type, entityID, entityData, refreshExistingTab, tabStrip, tabRegisterSecret){
			var self = this;
			var entityAttributes = (entityData || {}).attributes || {};
			var entityPrefix = '';
			var entityTitle = '';
			var entityIcon = '';
			var performActionGranted = false;
			var baseActionKey = 'showEdit_' + (type || '');
			var actionSuffix = '';

			if(type === 'product'){
				performActionGranted = true;
				entityIcon = 'fi fi-shop-product';
				if(entityAttributes.name) 	entityTitle = entityAttributes.name;
				actionSuffix = entityID;
			}
			if(this.hasRoleOption('showIDs', 'mblx')){
				entityPrefix = '#' + entityID + ' - ' + entityPrefix;
			}


			if(performActionGranted && refreshExistingTab && tabStrip && tabRegisterSecret !== undefined){
				performActionGranted = false;

				var actionKey, action;
				for(actionKey in self.actions){
					if(
						(action = self.actions[actionKey]) &&
						action.originalActionKey === ('showEdit_' + type) &&
						(action.tabConnection || {}).tabRegisterSecret === tabRegisterSecret &&
						action.tabConnection.tabStripComponentIndex === tabStrip.componentIndex
					){
						tabStrip.refreshTab(tabRegisterSecret, {
							title: 	entityPrefix + ': ' + entityTitle,
							icon: 	entityIcon
						}, true);
						break;
					}
				}
			}

			if(performActionGranted){
				if(self.actions[baseActionKey]){
					const entityAttributes = entityData.attributes || {}
					return self.performAndStoreAction(
						baseActionKey + '_inEffect_' + actionSuffix,
						self.prepareAction(baseActionKey, undefined, {
							entity: 	{ resourceID: entityID },
							routeTreeParent: utils.replace(entityAttributes, { resourceID: entityAttributes.routeID || entityAttributes.id }),
							productsAdditionalInformationProperties: { resourceID: entityAttributes.productAdditionalInformationID },
							productProperties: { resourceID: entityAttributes.productID },
							productAttributes: entityAttributes,
							relation: 	{
								entityID
							},
							tabOptions: {
								title: 	entityPrefix + ': ' + entityTitle,
								icon: 	entityIcon
							}
						}, {
							source: {
								tabContent: {
									componentData: {
										config: {
											// startWithRegisterSecret: (data || {}).startWithRegisterSecret || 'routeContent'
										}
									}
								}
							}
						})
					);
				}
			}

			return utils.promise.reject();
		},

		showDuplicate: function(type, entityID, entityData){
			var self = this;
			var typeGranted = false;
			var baseActionKey = 'showDuplicate_' + (type || '');

			if(type === 'product'){
				typeGranted = true;
			}

			if(typeGranted && self.actions[baseActionKey]){
				const entityAttributes = entityData.attributes || {}
				return self.performAndStoreAction(
					undefined,
					this.prepareAction(baseActionKey, entityID, {
						routeTreeParent: utils.replace(entityAttributes, { resourceID: entityAttributes.routeID || entityAttributes.id }),
					}),
					true
				);
			}

			return utils.promise.reject();
		},

		showProtocol: function(type, entityID, entityData){
			const baseActionKey = 'showProtocol'
			const actionKey		= baseActionKey + '_inEffect';
			const entityType 	= 'route'
			const entityContext	= type

			if(entityID){
				return this.performAndStoreAction(
					actionKey,
					this.prepareAction(baseActionKey, undefined, {
						protocol: {
							entityID,
							entityType,
							entityContext
						}
					}),
					true
				);
			}

			return utils.promise.reject();
		},

		delete: function(type, entityID, entityData){
			var self = this;
			var typeGranted = false;
			var baseActionKey = 'delete_' + (type || '');

			if(type === 'product'){
				typeGranted = true;
			}

			if(typeGranted && self.actions[baseActionKey]){
				return self.performDecision(
					'confirm',
					{
						component:  self,
						title:      storage.__(`hint.delete.really.mblx.${type}.title`),
						message:    storage.__(`hint.delete.really.mblx.${type}.message`),
					}
				).then(function(context){
					if(context.decision.type === 'yes'){
						return self.performAction(self.prepareAction(baseActionKey, entityID))
							.then(function(){
								self.callHandler('onDeleteMBLXProduct', [entityID])
							})
					}

					return utils.promise.resolve()
				})
			}

			return utils.promise.reject();
		},

		async requestProductAdditionalInformation(type, entityID, entityData, filters, nrOfExpectedMatchingElements = 0, nrOfExtectedEditStatusPimElements = 0){
			try {
				const resourceFilters = {
					status: 'transport',
					dryRun: true,
				}

				if(type === 'product' || type === 'productAdditionalInformation'){
					const entityAttributes = (entityData || {}).attributes || {}
					const number = entityAttributes.number
					if(!number){
						return await this.performMessage({
							messageDisplay: {
								message: 'error:mblx.productAdditionalInformation.requestProductAdditionalInformation.missingNumber',
							}
						})
					}

					if(entityAttributes.editStatus === 'pim'){
						nrOfExtectedEditStatusPimElements = 1
					}

					resourceFilters.numbers = [number]
				} else if(type === 'productFilters'){
					resourceFilters.productFilters = filters || {}
				} else if(type === 'productAdditionalInformationFilters'){
					resourceFilters.productAdditionalInformationFilters = filters || {}
				} else {
					return await this.performMessage({
						messageDisplay: {
							message: 'error:mblx.productAdditionalInformation.requestProductAdditionalInformation.invalidType',
						}
					})
				}

				if(nrOfExpectedMatchingElements > 100){
					const confirmationContext = await this.performDecision(
						'confirm',
						{
							component:  this,
							title:      storage.__('hint.mblx.requestProductAdditionalInformation.softLimitReached.title'),
							message:    storage.__('hint.mblx.requestProductAdditionalInformation.softLimitReached.message', { nrOfMatchingElements: nrOfExpectedMatchingElements })
						}
					)
					if(confirmationContext.decision.type !== 'yes'){
						return
					}
				}
				if(nrOfExtectedEditStatusPimElements > 0){
					const confirmationContext = await this.performDecision(
						'confirm',
						{
							component:  this,
							title:      storage.__('hint.mblx.requestProductAdditionalInformation.editStatusPimElementsFound.title'),
							message:    storage.__('hint.mblx.requestProductAdditionalInformation.editStatusPimElementsFound.message', { nrOfMatchingElements: nrOfExtectedEditStatusPimElements })
						}
					)
					if(confirmationContext.decision.type !== 'yes'){
						return
					}
				}

				// get data for summary via resourceFilters.dryRun === true
				const actionContext = await this.performAction(
					this.prepareAction('productAdditionalInformationSetExternalApiStatus', undefined, undefined, {
						source: {
							submit: {
								data: {
									resourceFilters,
								}
							}
						}
					}),
					false
				)

				// prompt availability checks
				const attributes = (((actionContext || {}).response || {}).data || [])[0] || {}
				const {promptAvailability} = attributes

				// show summary
				const {
					decision: promptAvailabilitySummaryDecision = {}
				} = await this.performDecision(
					'showMblxPromptAvailabilitySummaryForm',
					{
						component:  this,
						promptAvailability,
					}
				)

				// check if status was ready to write or fix it via user-modal-interaction until it is.
				resourceFilters.dryRun = false
				resourceFilters.promptAvailabilitySummaryDecision = promptAvailabilitySummaryDecision
				let showReRunHint = false
				let requestNumbersChangedGranted = false
				const manualPromptDecisions = resourceFilters.manualPromptDecisions = this.model.manualPromptDecisions = {}

				do {
					// try to write final mblx_productAdditionalInformation records.
					const actionContext = await this.performAction(
						this.prepareAction('productAdditionalInformationSetExternalApiStatus', undefined, undefined, {
							source: {
								submit: {
									data: {
										resourceFilters,
									}
								}
							}
						}),
						false
					)

					// prompt availability checks
					const attributes = (((actionContext || {}).response || {}).data || [])[0] || {}
					;({requestNumbersChangedGranted = false} = attributes)

					// show success
					if(requestNumbersChangedGranted){
						// tell other components about changes
						this.callHandler('productAdditionalInformationRequested')

						// show summary message
						const nrOfElementsPrevented = utils.collectionSize(attributes.numbersPrevented)
						const nrOfElementsChanged = utils.collectionSize(attributes.numbersChanged)
						const nrOfElementsRequested = nrOfElementsChanged
						const nrOfElements = nrOfElementsPrevented + nrOfElementsChanged

						return await this.performMessage({
							messageDisplay: {
								message: 'productAdditionalInformation.requestProductAdditionalInformation.summary',
								variables: {
									nrOfElements,
									nrOfElementsPrevented,
									nrOfElementsChanged,
									nrOfElementsRequested,
								}
							}
						})
					}

					// prepare missing manual prompt decisions
					let outstandingDecisionFound = false
					let nrOfOutstandingDecisions = 0
					for(const nr of Object.values(attributes.numbersPreventedByPromptDecisionDemand || [])){
						manualPromptDecisions[nr] = manualPromptDecisions[nr] || {
							decision: 'outstanding'
						}
						outstandingDecisionFound = outstandingDecisionFound || manualPromptDecisions[nr].decision === 'outstanding'

						if(manualPromptDecisions[nr].decision === 'outstanding'){
							nrOfOutstandingDecisions++
						}
					}

					// either requestNumbersChangedGranted = true or outstandingDecisionFound = true.
					// but a mismatch would be some true error condition.
					if(!outstandingDecisionFound){
						return console.error('no outstanding elements but requestNumbersChangedGranted === false???')
					}

					// in case the user wants to generate but has not decided for all elements yet this message will be shown.
					if(showReRunHint){
						const messageBaseName = 'product.manualPromptAssociations.reRunMessage'
						await this.performDecision(
							'confirm',
							{
								component:  this,
								title:      storage.__(messageBaseName + '.title'),
								message:    storage.__(messageBaseName + '.message', { nrOfElements: nrOfOutstandingDecisions }),
								buttons: [
									{
										mode: 'ok',
										buttonType: 'submit'
									}
								]
							}
						)
					}

					// show modal for user to decide what promptIDs to use for what product.
					const {
						decision: newManualPromptDecisions = {}
					} = await this.performDecision(
						'showMblxProductPromptAssociationsDecider',
						{
							component:  this,
							manualPromptDecisions,
						}
					)

					// TODO: check for cancel
					if(utils.collectionSize(newManualPromptDecisions) < 1){
						// TODO: show hint that it has to be done
					}

					for(const [nr, promptDecision] of Object.entries(newManualPromptDecisions)){
						manualPromptDecisions[nr] = promptDecision
					}

					showReRunHint = true

				} while(!requestNumbersChangedGranted)
			} catch (errorContext) {
				if((errorContext || {}).errorUnhandled !== false){
					console.error(errorContext)
					await this.performMessage({
						messageDisplay: {
							message: 'error:mblx.productAdditionalInformation.requestProductAdditionalInformation.unknown',
						}
					})
				}
			}
		},
	},

	hooks: {
		async onDecision($element, options){
			switch(options.decisionType){
				case 'submit':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							var modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component;
							if(modalContentComponent && modalContentComponent.hasClass('templates_propertiesForms_routePropertiesForm')){
								const context = await modalContentComponent.submit()
                                await options.decisionComponent.hide()

                                var routeData = ((context || {}).response || {}).data || {};
                                var routeAttributes = routeData.attributes || {};
                                var routeID = routeAttributes.routeID || routeAttributes.id;
                                await this.showEdit('product', routeID, routeData)
							}
							break;
					}
					break;

				case 'cancel':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							await options.decisionComponent.hide()
							break;
					}
					break;

				default:
					// TODO: ERROR;
					break;
			}
		},
	}
}
